import { render, staticRenderFns } from "./LinkedRecordCell.vue?vue&type=template&id=77d4cc5a&scoped=true"
import script from "./LinkedRecordCell.vue?vue&type=script&lang=js"
export * from "./LinkedRecordCell.vue?vue&type=script&lang=js"
import style0 from "./LinkedRecordCell.vue?vue&type=style&index=0&id=77d4cc5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4cc5a",
  null
  
)

export default component.exports